import React, { PureComponent } from 'react';

import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { Branch } from 'src/components/types';
import urls from 'src/sections/repository/urls';
import {
  getCurrentRepositoryOwnerName,
  getCurrentRepositorySlug,
} from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';

import messages from './create-pull-request-link.i18n';
import * as styles from './create-pull-request-link.styled';

type ConnectedProps = {
  createPullRequestUrl: string;
};

type OwnProps = {
  branchName: Branch['name'];
};

type Props = OwnProps & ConnectedProps;

export const mapStateToProps = (
  state: BucketState,
  ownProps: OwnProps
): ConnectedProps => {
  const { branchName } = ownProps;
  const owner = getCurrentRepositoryOwnerName(state);
  const slug = getCurrentRepositorySlug(state);

  const url = `${urls.ui.createPullRequest(
    owner || '',
    slug || '',
    branchName
  )}&event_source=branch_list`;

  return {
    createPullRequestUrl: url,
  };
};

export default connect<ConnectedProps>(mapStateToProps)(
  class CreatePullRequestLink extends PureComponent<Props> {
    render() {
      return (
        <styles.CreatePullRequestClientLink
          href={this.props.createPullRequestUrl}
        >
          <FormattedMessage {...messages.createPullRequestLinkText} />
        </styles.CreatePullRequestClientLink>
      );
    }
  }
);
